import { defineAsyncComponent } from 'vue'
export default {
  "advice-post": defineAsyncComponent(() => import("/var/www/jobeek/layouts/advice-post.vue")),
  advice: defineAsyncComponent(() => import("/var/www/jobeek/layouts/advice.vue")),
  auth: defineAsyncComponent(() => import("/var/www/jobeek/layouts/auth.vue")),
  custom: defineAsyncComponent(() => import("/var/www/jobeek/layouts/custom.vue")),
  default: defineAsyncComponent(() => import("/var/www/jobeek/layouts/default.vue")),
  guest: defineAsyncComponent(() => import("/var/www/jobeek/layouts/guest.vue")),
  main: defineAsyncComponent(() => import("/var/www/jobeek/layouts/main.vue"))
}